const baseURL = "/v1/Administracao/Grupo";

const service = {
  methods: {
    $buscarGrupos(params) {
      return this.$api().get(`${baseURL}`, params);
    },
    $visualizarGrupos({ params, id }) {
      return this.$api().get(`${baseURL}/${id}`, params);
    },
    $cadastrarGrupo(body) {
      return this.$api().post(`${baseURL}`, body);
    },
    $editarGrupo(body, id) {
      return this.$api().put(`${baseURL}/${id}`, body);
    },
    $inativarAtivarGrupo(id) {
      return this.$api().patch(`${baseURL}/${id}/AlterarStatus`);
    }
  },
};

export default service;
